'use client';

/**
 * 소재의 공유 링크 복사 — 원문 주소가 아니라 우리 공유 페이지 주소(`toMediaSharePath`)를 복사한다. 카드와 상세 다이얼로그가 함께 쓴다.
 *
 * 복사·토스트·기록은 `useCopyShareLink` 한 벌이다(브랜드·크리에이터 허브 공유와 같은 말).
 */

import { useCallback } from 'react';

import { useCopyShareLink } from 'src/sections/common/hooks/handler/use-copy-share-link';

import { toMediaSharePath } from '../../utils/search-all-share-link';

import type { MediaCard } from '../../utils/search-all-media-cards';

/** @param query 지금 검색어 — 공유 페이지 뒤에 깔린다 */
export function useSearchAllShare(query: string) {
  const copy = useCopyShareLink();
  return useCallback((card: MediaCard) => copy(toMediaSharePath(card, query), 'search-all.detail.share'), [copy, query]);
}
